import { defineStore } from 'pinia'

export const SecretBooba = defineStore('SecretBooba', {
    state: () => {
        return { SecretBooba: false }
    },
    actions: {
        get() {
            return this.SecretBooba
        },
        set(value) {
            this.SecretBooba = value
        }
    },
})